export enum ContentLayout7Theme {
  BLUE = 'BLUE',
  OPAL = 'OPAL',
}
